import { Button } from "@/components/Button/Button";
import { faCircleRight } from "@fortawesome/free-solid-svg-icons";
import { MediaLogos } from "@/components/MediaLogos";
import mapSvg from "@/assets/maps.svg";
import Intercom, { show as showIntercomOverlay } from "@intercom/messenger-js-sdk";
import { useEffect } from "react";
import { useIsLocationAllowed } from "@/hooks/useIsLocationAllowed";
import { SafePaddingContainer } from "@/components/SafePaddingContainer";

export function SkillScratchUnavailablePage() {
    const [isLocationAllowed] = useIsLocationAllowed();

    useEffect(() => {
        // Initialize Intercom with app_id
        Intercom({
            app_id: "zm7q6jbf",
            // No user_id or name since user isn't logged in
            // Optionally add any visitor information if needed
            anonymous_id: "unavailable_page_visitor"
        });
    }, []);
    
    return (
        <div className="flex flex-col h-screen bg-white">
            <SafePaddingContainer orientation="header" className='h-[100%]'>
                {/* Blue background with clip path */}
                <div 
                    className="absolute inset-0"
                    style={{
                        clipPath: 'polygon(0px 0px, 100% 0px, 100% 49%, 0px 52%)',
                        zIndex: 0,
                        backgroundColor: '#DFF3FF',
                    }}
                >

                    {/* biome-ignore lint/a11y/useAltText: <explanation> */}
                    <img
                        src={mapSvg}
                        className='h-36 m-auto mt-[50%]'
                    />

                </div> 
            </SafePaddingContainer>
            
            <SafePaddingContainer orientation="footer" className='h-full'>
                {/* <Logo
                    style={{
                    paddingTop: "55vh",
                    margin: "0 auto",
                    width: "70%",
                    }}
                /> */}

                <div className='flex justify-between flex-col h-full'>
                    <p className="text-center text-2xl font-semibold text-dark-blue2 leading-normal mt-12">
                        {`Apologies! SkillScratch isn't available yet in ${isLocationAllowed?.locationName}. We'll notify you once we are.`}
                    </p>
                    
                    <div>
                        <Button
                            style={{
                                fontSize: "1.8em",
                                marginBottom: "0.5em",
                                marginTop: "auto",
                            }}
                            text='Contact Us'
                            icon={faCircleRight}
                            onClick={() => {
                                showIntercomOverlay();
                            }}
                            fillWidth
                        />

                        <MediaLogos />
                    </div>
                </div>
            </SafePaddingContainer>
        </div>
    )
}